import type { Point, PointArray } from '../types/contour-definition-array-type';

import {
  getPointPointDistance,
  getPointPointDistanceArray,
} from './getPointPointDistance';

/**
 *
 * @param point target coordinates
 * @param points PointArray of coordinates
 * @returns index of the closest point in PointArray to target point
 */
export function getClosestPointIdx(point: Point, points: PointArray): number {
  let distQuadr = getPointPointDistance(point, points[0]);
  let shortestDistQuadr = distQuadr;

  let idxClosest = 0;

  for (let i = 1; i < points.length; i++) {
    distQuadr = getPointPointDistance(point, points[i]);

    if (distQuadr < shortestDistQuadr) {
      shortestDistQuadr = distQuadr;
      idxClosest = i;
    }
  }
  return idxClosest;
}

/**
 * Get the index of the closest point in a number[][] array to a target point
 * @param point target coordinates [x, y]
 * @param points Array of coordinates as number[][]
 * @returns index of the closest point to target point
 */
export function getClosestPointArrayIdx(point: number[], points: number[][]) {
  let distQuadr = getPointPointDistanceArray(point, points[0]);
  let shortestDistQuadr = distQuadr;

  let idxClosest = 0;

  for (let i = 1; i < points.length; i++) {
    distQuadr = getPointPointDistanceArray(point, points[i]);

    if (distQuadr < shortestDistQuadr) {
      shortestDistQuadr = distQuadr;
      idxClosest = i;
    }
  }
  return idxClosest;
}
